import React, { useContext, useState } from "react";
import { Button, Modal, Select, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useGlobalToast } from "../../context/ToastProvider";
import { DriverContext } from "../../context/DriverContext";
import { API_REQUEST_HEADERS_BASEURL } from "../../utils/Constants";
import { fleetErrorMessage } from "../../utils/fleetFeedback";

export default function ChangeActiveDriver({ fleetId, orderId, order, onChanged, asSelect = false }) {
  const { t } = useTranslation();
  const toast = useGlobalToast();
  const { driversDetails = [] } = useContext(DriverContext);
  const [open, setOpen] = useState(false);
  const [driverId, setDriverId] = useState(null);
  const [busy, setBusy] = useState(false);
  const selected = driversDetails.find(driver => driver.id === driverId);
  const profilePlate = String(selected?.headId || "").trim();
  const plate = order.truck?.plateSources?.headId === 'DRIVER' || !order.truck?.headId
    ? profilePlate : String(order.truck.headId).trim();
  const hasEDoc = Boolean(order.freightDocumentId);
  const save = async () => {
    setBusy(true);
    try {
      const response = await API_REQUEST_HEADERS_BASEURL.post(`/fleets/${fleetId}/transportOrder/${orderId}/reassign-driver`, {
        driverId, expectedDriverId: order.userId, expectedPlate: profilePlate, confirmed: true,
      });
      setOpen(false);
      toast({ title: t("orderDetail.reassign.success"), status: "success" });
      onChanged({driverId, truck: response.data.truck});
    } catch (error) {
      toast({ title: fleetErrorMessage(t, error, t("orderDetail.reassign.documentUnavailable")), status: "error", duration: 8000, isClosable: true });
      onChanged();
    } finally { setBusy(false); }
  };
  const options = driversDetails.map(driver => ({
    value: driver.id, label: driver.name || driver.id,
    disabled: !driver.detailsLoaded || driver.currentFleet !== fleetId || Boolean(driver.currentOrder && driver.currentOrder !== orderId),
  }));
  return <>
    {asSelect ? <Select style={{width:'100%'}} showSearch optionFilterProp="label"
      title={t('selectDriver')} placeholder={t('selectDriver')} value={order.userId || undefined}
      disabled={busy} options={options} onChange={value=>{
        if(value!==order.userId){setDriverId(value);setOpen(true);}
      }} /> : <Button onClick={() => { setDriverId(null); setOpen(true); }}>{t("orderDetail.reassign.title")}</Button>}
    <Modal open={open} title={t("orderDetail.reassign.title")} onCancel={() => !busy && setOpen(false)}
      confirmLoading={busy} closable={!busy} maskClosable={!busy} keyboard={!busy}
      okText={t("orderDetail.reassign.confirm")} cancelText={t("orderDetail.reassign.cancel")}
      okButtonProps={{ disabled: !selected || (hasEDoc && !plate) }} onOk={save}>
      <Select style={{ width: "100%" }} showSearch optionFilterProp="label" value={driverId}
        placeholder={t("selectDriver")} onChange={setDriverId} disabled={busy}
        options={options.filter(driver => driver.value !== order.userId)} />
      {selected && <Typography.Paragraph style={{ marginTop: 16 }}>
        {hasEDoc ? (plate ? t("orderDetail.reassign.edocConfirmation", { plate }) : t("orderDetail.reassign.missingPlate")) : t("orderDetail.reassign.orderConfirmation")}
      </Typography.Paragraph>}
    </Modal>
  </>;
}
